import { SelectControl, TextareaControl } from '@/frontend/features/Fde/FormControls'
import type { Evidence, FdeCopy } from '@/frontend/features/Fde/types'

interface Props {
  changeNote: string
  evidenceId: string
  evidences: Evidence[]
  copy: FdeCopy
  onChangeNote: (value: string) => void
  onEvidenceId: (value: string) => void
  className?: string
}

export default function ChangeContextFields(props: Props) {
  const evidenceOptions = [
    { value: '', label: props.copy.forms.no_change_evidence },
    ...props.evidences.map((evidence) => ({ value: evidence.id, label: evidence.title })),
  ]

  return <div className={props.className}>
    <div className="grid gap-4 rounded-lg border border-border bg-muted/20 p-3">
      <TextareaControl label={props.copy.forms.change_note} value={props.changeNote} onChange={(event) => props.onChangeNote(event.target.value)} rows={2} />
      <SelectControl label={props.copy.forms.change_evidence} value={props.evidenceId} onChange={props.onEvidenceId} options={evidenceOptions} />
      <p className="text-[11px] leading-4 text-muted-foreground">{props.copy.forms.change_context_hint}</p>
    </div>
  </div>
}
